/*
 This file is part of GNU Taler
 (C) 2021-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

/**
 *
 * @author Sebastian Javier Marchano (sebasjm)
 */

import { TalerMerchantApi } from "@gnu-taler/taler-util";
import { h, VNode } from "preact";
import { CardTableIncoming, CardTableVerified } from "./Table.js";
import { PaginatedResult } from "@gnu-taler/web-util/browser";

const TALER_SCREEN_ID = 71;

export interface Props {
  transfers: PaginatedResult<TalerMerchantApi.TransferDetails[]>;
  incomings: PaginatedResult<TalerMerchantApi.ExpectedTransferEntry[]>;
  onDetails: (wid: number) => void;
}

export function ListPage({ transfers, incomings, onDetails }: Props): VNode {
  return (
    <section class="section is-main-section">
      {!incomings.body.length ? undefined : (
        <CardTableIncoming
          transfers={incomings.body.map((o) => ({
            ...o,
            id: String(o.wtid),
          }))}
          onLoadMoreBefore={incomings.loadFirst}
          onLoadMoreAfter={incomings.loadNext}
          onDetails={onDetails}
        />
      )}
      {/* // ) : ( */}
      <CardTableVerified
        transfers={transfers.body.map((o) => ({
          ...o,
          id: String(o.wtid),
        }))}
        onLoadMoreBefore={transfers.loadFirst}
        onLoadMoreAfter={transfers.loadNext}
        onDetails={onDetails}
      />
      {/* // )} */}
    </section>
  );
}
